import ServiceCategoryPage from "../components/ServiceCategoryPage";
import carpenterService from "../data/services/carpenterService";

function Carpenter() {
  return <ServiceCategoryPage service={carpenterService} />;
}

export default Carpenter;